import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { IModalData } from "@edp-components/edp-modal/edp-modal.models";
import { EdpModalService } from "@edp-components/edp-modal";
import { EdpToastType } from "@edp-components/edp-toaster/edp-toast-type";
import { EdpToasterService } from "@edp-components/edp-toaster/edp-toaster.service";
import { Store, select } from "@ngrx/store";
import { IAppState } from "@edp-store/state/app.state";
import { getBankList } from "@edp-store/selectors/dashboard.selectors";
import { SetBankList } from "@edp-store/actions/dashboard.actions";
import { DashboardService } from "@edp-services/dashboard.service";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { takeUntil, filter } from "rxjs/operators";
import { IBankList } from "@edp-models/bank.model";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { Contract } from "@edp-components/edp-contract";
import { DatalayerService } from "@edp-services/datalayer.service";

@Component({
    selector: "edp-open-banking-modal",
    templateUrl: "./edp-open-banking-modal.component.html",
    styleUrls: ["./edp-open-banking-modal.component.scss"]
})
export class EdpOpenBankingModalComponent implements OnInit, OnDestroy {
    @Input() public data: IModalData;

    public arrayBanks: IBankList[];
    public bankListSelected: IBankList[] = [];
    public loading = true;

    private unsubscribe$: Subject<void> = new Subject();
    contract: Contract;

    constructor(
        private store: Store<IAppState>,
        private edpModalService: EdpModalService,
        private toaster: EdpToasterService,
        private dashboardService: DashboardService,
        private translate: TranslateService,
        private datalayerService: DatalayerService
    ) {
        // get full banks list
        this.dashboardService
            .getBanksList()
            .subscribe((resp: IBankList[]) => {
                this.arrayBanks = resp;
                this.arrayBanks = this.arrayBanks.sort((a, b) => a.order - b.order);
                this.loading = false;
            });

        this.store.pipe(
            takeUntil(this.unsubscribe$),
            select(getContract)
        ).subscribe(contract => {
            this.contract = contract;
        });
    }


    public ngOnInit() {
        // get selected banks list
        this.store.pipe(
            takeUntil(this.unsubscribe$),
            select(getBankList),
            filter(v => !!v)
        ).subscribe((bankList: IBankList[]) => {
            this.bankListSelected = bankList;
            this.loading = true;
        });
    }

    public dismissModal(): void {
        this.edpModalService.dismiss(false);
    }

    private datalayerBankClick(interactionName: string): void {
        this.datalayerService.setGaClick("clickNavigation", {
            formType: "faturacao",
            interactionName: interactionName.toLowerCase().replace(" ", "-"),
            interactionLocation: "open-banking-modal"
        });

        this.datalayerService.setGaEvent("paymentOBAddBankClose");
    }

    public bankClick(bank) {
        const listBank: IBankList[] = [...this.bankListSelected, bank];
        this.store.dispatch(new SetBankList(listBank));
        this.dashboardService.insertBanks(listBank, this.contract.ContractId).subscribe(() => { /* Intentionally silent */ });
        if (!(this.data as any).editMessageDisplayed) {
            this.toaster.create(this.translate.instant("pt.edp.edponline.open.banking.modal.message"), EdpToastType.info).show();
        }
        this.datalayerBankClick(bank.institution_name);

        this.edpModalService.close(false);
    }


    public ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}

